export default __webpack_public_path__ + "static/graphik-web-bold-bd2d43044062be7d27c31146775ad63c.woff2";